import axios from 'axios';
import API from './API';


export const Floors_Add = (data) => API.post('Floors/Add', data);
export const Floors_Get_All = () => {
  return API.get("Floors/Get_All");
};
export const Floors_Get = (ID) => {
  const Token = localStorage.getItem("Token");
  return API.get(`Floors/Get/${ID}`, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
};

export const Floors_Update = (ID, Data) => {
  const Token = localStorage.getItem("Token");
  return API.post(`Floors/Update/${ID}`, Data, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
};
export const Floors_Delete = (ID) => {
  const Token = localStorage.getItem("Token");
  return API.delete(`Floors/Delete/${ID}`, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
}

export const Floors_Restore_Single = (ID) => {
  const Token = localStorage.getItem("Token");
  return API.post(`Floors/Restore/${ID}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${Token}`
      }
    });
}

export const Floors_Restore_Cascade = (ID) => {
  const Token = localStorage.getItem("Token");
  return API.post(`Floors/Restore_Cascade/${ID}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${Token}`
      }
    });
}

export const Floors_Upload_Image = (formData) =>
  API.post('Upload/floor-plan', formData, {
    headers: { "Content-Type": "multipart/form-data" }
  });